export enum DOCUMENT_FORMAT_TYPE {
  PDF = 'pdf',
  WORD = 'doc',
}

export const DOCUMENT_FORMAT_TYPE_LIST = [
  { id: DOCUMENT_FORMAT_TYPE.PDF, displayValue: 'PDF' },
  { id: DOCUMENT_FORMAT_TYPE.WORD, displayValue: 'Word' },
];
